import _ from 'underscore';
import startsWith from 'underscore.string/startsWith';
import PasswordGenerator from './util/passwordGenerator.js';
import ContextualSidebar from './views/components/contextual-sidebar.js';
import Alert from './views/components/alert.js';
import Router from './router.js';
import Tabs from './views/tabs.js';
import Header from './views/header.js';

module.exports = function () {
  let router,
    refreshPlugins,
    unloadPlugins,
    passwordGenerator = new PasswordGenerator(),
    countrySelect,
    subdivisionsSelect,
    onCountryChange,
    setSubdivisionLoadingState;

  window.refreshTabs = function () {
    new Tabs();
  };

  refreshPlugins = function () {
    $('.show_fields').zebra();
    passwordGenerator.attach();

    new Header({ el: '.header' });
    new ContextualSidebar();
    new Alert({ dom: $('.alert-box:not(.persistent)') });

    $('.ui.dropdown:not(.prop):not(.react-component)').dropdown();
    $('.select2-initialize').select2({ placeholder: '' });
    refreshTabs();

    $(
      'select:not(.select2-hidden-accessible):not([multiple="multiple"]):not(.ip-field), .io-form select:not(.select2-hidden-accessible):not(.no-initialize):not(.ip-field)',
    ).select2({
      placeholder: '',
    });

    countrySelect = $('#country-select');
    subdivisionsSelect = $('#subdivisions-select');

    if (countrySelect.length && subdivisionsSelect.length) {
      countrySelect.on('change', onCountryChange);
    }

    // This is done cause a limitation on the options for Select2. Currently it does not support any option
    // to automatically close the dropdown after unselect event
    // Info: https://select2.org/configuration/options-api
    // Also check this issue: https://github.com/select2/select2/issues/5699
    $('select[multiple]').on('select2:unselect', function (event) {
      if (event.params.originalEvent) {
        event.params.originalEvent.stopPropagation();
      }
    });

    addBackToTop({
      zIndex: 1000,
      diameter: 56,
      backgroundColor: '#24272A',
      textColor: '#fff',
    });
  };

  unloadPlugins = function () {
    passwordGenerator.destroy();

    // remove click handler on document
    $('.ui.dropdown:not(.prop):not(.react-component)').off();

    // destroy select2 and remove any event that we added
    $('.select2-initialize').select2('destroy');
    $('.select2-initialize').off('select2:select');

    if (countrySelect.length) {
      countrySelect.off('change', onCountryChange);
    }
  };

  onCountryChange = function () {
    const country = $(this).val();
    setSubdivisionLoadingState();

    $.getJSON(
      `/${currentCustomer}/locations/subdivisions?country=${country}`,
      function (data) {
        const dataOptions = [];

        if (data.length === 0) {
          // empty option so Rails submits an empty string for subdivisions
          dataOptions.push(['', '']);
          subdivisionsSelect.closest('tr').addClass('hide');
        } else {
          const options = data.map((subdivision) => ({
            text: subdivision[0],
            id: subdivision[1],
          }));

          dataOptions.push(...options);
          subdivisionsSelect.closest('tr').removeClass('hide');
        }

        subdivisionsSelect
          .select2('destroy')
          .empty()
          .removeAttr('disabled')
          .select2({
            data: dataOptions,
          })
          .trigger('change');
      },
    );
  };

  setSubdivisionLoadingState = function () {
    subdivisionsSelect
      .select2('destroy')
      .empty()
      .select2({
        data: ['Loading...', ''],
      })
      .attr('disabled', 'disabled')
      .trigger('change');
  };

  // overriding default value
  $.fn.select2.defaults.set('matcher', function (params, data) {
    if (!data || data.text == null) {
      return null;
    }
    // Creatable tags (IP field, etc.): typed term matches option id/text exactly.
    if (
      params.term != null &&
      String(data.text).trim() === String(params.term).trim()
    ) {
      return data;
    }

    var search = (params.term || '').toLowerCase().trim(),
      matcher = data.text.toLowerCase().trim(),
      matchUnderscore = _.some(matcher.split('_'), (i) =>
        startsWith(i, search),
      ),
      matchSpace = _.some(matcher.split(' '), (i) => startsWith(i, search)),
      matchPart = matcher.indexOf(search) > -1;

    if (
      startsWith(matcher, search) ||
      matchUnderscore ||
      matchSpace ||
      matchPart
    ) {
      return data;
    }
    return null;
  });

  router = new Router();

  router.on('error', () => {
    refreshPlugins();
  });

  $(document).on('turbolinks:before-render', () => unloadPlugins());

  $(document).on('turbolinks:load', () => {
    refreshPlugins();
    router.load();
    window.PersistentActions.startListening();
  });

  $(document).on('htmx:replacedInHistory', (event) => {
    Turbolinks.controller.replaceHistoryWithLocationAndRestorationIdentifier(
      event.detail.path,
      Turbolinks.uuid(),
    );
  });

  $.expr[':'].contains = $.expr.createPseudo(function (arg) {
    return function (elem) {
      return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
  });

  // This is a workaround for a turbolinks bug (https://github.com/rails/rails/issues/29473)
  // There are two patches for upcoming Rails and Turbolinks releases:
  // Rails: https://github.com/rails/rails/pull/31441
  // Turbolinks: https://github.com/turbolinks/turbolinks-rails/pull/28
  // The below piece of code can be removed as soon as we upgrade to a Rails version that
  // make use of such patches.
  $(document).on(
    'ajax:complete',
    'form[method!=get][data-remote=true]',
    function (e, xhr) {
      if (xhr.responseText.substring(0, 10) == 'Turbolinks') {
        $.rails.disableFormElements($(e.target));
      }
    },
  );

  document.addEventListener(
    'mousewheel',
    function (e) {
      if (document.activeElement.type === 'number') {
        e.preventDefault();
      }
    },
    { passive: false },
  );

  document.addEventListener('keydown', function (e) {
    if (
      document.activeElement.type === 'number' &&
      (e.which === 38 || e.which === 40)
    ) {
      e.preventDefault();
    }
  });
};
